export const readString = (value: unknown): string | undefined =>
    typeof value === 'string' && value !== '' ? value : undefined;

export const readObject = (value: unknown): Record<string, unknown> | undefined =>
    value && typeof value === 'object' ? (value as Record<string, unknown>) : undefined;
